import moment = require("moment");
import { getAsNumber, isNumber, isString } from "./components/utilities";

declare var persianDate:(any)=>void;

export class Converters{
    notConverter(t){
        return !t;
    }
    numberToString(n:number){
        if(n)
            return n.toString();
        return "0";
    }
    stringToInt(s:string){
        if(s==null)
            return 0;
        let v = parseInt(s);
        if(isNaN(v))
            return 0;
        return v;
    }

    CustomPersianDateConverter(d:moment.Moment,format:string):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        d = d.clone().local();
        let date = new persianDate(d.toDate());
        let result = date.format(format)
        return result;
    }
    
    onlyDatePersianDateConverter(d:moment.Moment):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        d = d.clone().local();
        let date = new persianDate(d.toDate());
        let result = date.format(`dddd YYYY/MM/DD`)
        return result;
    }
    onlyDateNoWeekDayPersianDateConverter(d:moment.Moment):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        d = d.clone().local();
        let date = new persianDate(d.toDate());
        let result = date.format(`YYYY/MM/DD`)
        return result;
    }
    onlyTimePersianDateConverter(d:moment.Moment):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        d = d.clone().local();
        let date = new persianDate(d.toDate());
        let result = date.format(`HH:mm:ss`)
        return result;
    }
    persianDateConverter(d:moment.Moment,separator?:string):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        if(separator==null) separator='|';
        d = d.clone().local();
        let date = new persianDate(d.toDate());
        let result = date.format(`HH:mm:ss ${separator} dddd YYYY/MM/DD`)
        return result;
    }
    
    persianDateConverterNoWeekDay(d:moment.Moment,separator?:string):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        if(separator==null) separator='|';
        d = d.clone().local();
        let date = new persianDate(d.toDate());
        let result = date.format(`HH:mm:ss ${separator} YYYY/MM/DD`)
        return result;
    }
    
    twoLinesPersianDateConverter(d:moment.Moment,separator?:string):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        if(separator==null) separator='|';
        d = d.clone().local();
        let date = new persianDate(d.toDate());
        let result = date.format('YYYY/MM/DD\r\ndddd HH:mm:ss')
        return result;
    }


    
    colorStatusConverterForListOfRequestsInOfficeApp(c){
        switch(c){
            case 0:
                return 'transparent';
            case 1:
                return 'var(--color6opac2)';
            case 2:
                return 'var(--color6opac2)';
            case 3:
                return 'var(--color8opac2)';
            case 4:
                return 'var(--color9opac2)';
            case 5:
                return 'var(--color4opac2)';
        }
        return 'transparent';
    }
    
    moneyConverter(v){
        if(v){
            let thousandSeparated = v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return `${thousandSeparated} ریال`;
        }else{
            return `0 ریال`;
        }
    }
    reverseMoneyConverter(v){
        if(v && isString(v)){
            let thousandSeparated = (<string>v).split(' ')[0];
            let numberString = thousandSeparated.replace(/,/g,"");
            return getAsNumber(numberString);
        }else{
            return 0;
        }
    }

    b64ToSrcConverter(t){
        return `data:image/png;base64,${t}`;
    }
    b64ToSrcConverterReverse(t){
        if(t && isString(t) && t.indexOf(',')>-1)
            return t.split(',')[1];
        return null;
    }
}